import SchoolSelect from "./SchoolSelect"

const Schools = ()=>{
    
    return <SchoolSelect />
}

export default Schools